import groq from 'groq';

import { ASSET } from '../common/asset';
import { OVERLINE } from '../common/overline';
import { RICH_TEXT } from '../common/richText';

export const CATEGORIES_INTRO = groq`
  _type,
  ${OVERLINE},
  title,
  categories[] {
    _key,
    overline,
    title,
    image {
      ${ASSET}
    },
    body[] {
      ${RICH_TEXT}
    }
  },
  cta {
    title,
    href
  }
`;

export const CATEGORIES_INTRO_BLOCK = groq`
  _type == 'categoriesIntro' => @-> {
    ${CATEGORIES_INTRO}
  }
`;
